import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';

import App from './App';
import * as serviceWorker from './serviceWorker';
import createStore from './redux/store';

import './index.css';
import 'antd/dist/antd.less';

const store = createStore();

const WithRouter = () => (
  <Router>
    <App />
  </Router>
);

const WithRedux = () => (
  <Provider store={store}>
    <WithRouter />
  </Provider>
);

ReactDOM.render(
  <React.StrictMode>
    <WithRedux />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
